export default __webpack_public_path__ + "static/media/policy12_2023.c53bda5b.jpg";